import TopicGroup from './TopicGroup';

export default TopicGroup;
